<h1 mat-dialog-title class="m-0 mb-1">
  {{modalOptions.title}}
</h1>
<div mat-dialog-content>
  <div class="p-0 mb-2" [innerHTML]="modalOptions.message"></div>
  <div class="p-0">
    <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-manax" (click)="dialog.close(true)">
      {{modalOptions.yesButtonLabel}}
    </button>
    <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link"
      (click)="dialog.close(false)">
      {{modalOptions.noButtonLabel}}
    </button>
  </div>
</div>